import { useMutation } from '@apollo/client';

export function useGqlMutation(mutation, options = {}) {
  const [executeMutation, { data, loading, error }] = useMutation(
    mutation,
    options
  );
  const execute = async (variables: any, context?: any) => {
    const result = await executeMutation({
      variables,
      context,
    });
    return result;
  };

  return { execute, data, loading, error };
}
